import { SvgIcon, SvgIconProps } from '@mui/material';
import React, { ReactElement } from 'react';

export interface ThreeSmileyCircleProps extends SvgIconProps {}

export const ThreeSmileyCircle = ({
  style,
  ...iconProps
}: ThreeSmileyCircleProps): ReactElement => {
  style = {
    fontSize: '1em',
    ...style,
  };

  return (
    <SvgIcon
      style={style}
      {...iconProps}
      width="83"
      height="80"
      viewBox="0 0 83 80"
      fill="none"
    >
      <circle
        cx="42.836"
        cy="39.6231"
        r="38.6231"
        fill="white"
        stroke="#23305F"
        strokeWidth="2"
      />
      <circle
        cx="39.6231"
        cy="39.6231"
        r="38.6231"
        stroke="#5CDA64"
        strokeWidth="2"
      />
      <path
        d="M41 49.5176C46.5228 49.5176 51 45.0404 51 39.5176C51 33.9947 46.5228 29.5176 41 29.5176C35.4772 29.5176 31 33.9947 31 39.5176C31 45.0404 35.4772 49.5176 41 49.5176Z"
        stroke="#23305F"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M37 41.5176C37 41.5176 38.5 43.5176 41 43.5176C43.5 43.5176 45 41.5176 45 41.5176"
        stroke="#23305F"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M44 36.5176H44.01"
        stroke="#23305F"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M38 36.5176H38.01"
        stroke="#23305F"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M21 49.5176C26.5228 49.5176 31 45.0404 31 39.5176C31 33.9947 26.5228 29.5176 21 29.5176C15.4772 29.5176 11 33.9947 11 39.5176C11 45.0404 15.4772 49.5176 21 49.5176Z"
        stroke="#23305F"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M17 41.5176C17 41.5176 18.5 43.5176 21 43.5176C23.5 43.5176 25 41.5176 25 41.5176"
        stroke="#23305F"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M24 36.5176H24.01"
        stroke="#23305F"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M18 36.5176H18.01"
        stroke="#23305F"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M61 49.5176C66.5228 49.5176 71 45.0404 71 39.5176C71 33.9947 66.5228 29.5176 61 29.5176C55.4772 29.5176 51 33.9947 51 39.5176C51 45.0404 55.4772 49.5176 61 49.5176Z"
        stroke="#23305F"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M57 41.5176C57 41.5176 58.5 43.5176 61 43.5176C63.5 43.5176 65 41.5176 65 41.5176"
        stroke="#23305F"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M64 36.5176H64.01"
        stroke="#23305F"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M58 36.5176H58.01"
        stroke="#23305F"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </SvgIcon>
  );
};
